import i18n from "i18n";

const handleError = (statusCode, errorMessage) => {
  const generic = i18n.t("common:errors.generic");
  if (!errorMessage) {
    return generic;
  }
  switch (statusCode) {
    case 400:
      return `${errorMessage}`;
    case 401:
      return generic;
    case 404:
      return `${errorMessage}`;
    case 403:
      return `${errorMessage}`;
    case 409:
      return `${errorMessage}`;
    case 422:
      return `${errorMessage}`;
    case 500:
      return generic;
    default:
      return generic;
  }
};

export default handleError;
